<mat-dialog-actions class="code-dialog-header">
    <button class="code-dialog-close" mat-dialog-close type="button" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
    </button>
</mat-dialog-actions>
<mat-dialog-content class="content-code">
    <div class="code-content">
        <!-- <img class="code-logo" src="../../../assets/logos-nina/nina-hd-black.png" alt="Nina Pastelería"> -->
        <h2 class="code-title">
            Código de confirmación
        </h2>
        <p class="code-subtitle">
            Ingresa el código que recibiste para continuar.
        </p>
        <form class="code-form" method="post" [formGroup]="codeConfirmForm" (ngSubmit)="confirm()">
            <!-- Código -->
            <div class="code-field">
                <label for="confirmation-code">
                    CÓDIGO DE CONFIRMACIÓN
                </label>
                <mat-form-field class="code-input" appearance="outline">
                    <input id="confirmation-code" class="input-number-withoutcontrols" matInput formControlName="code"
                        type="text" inputmode="numeric" pattern="[0-9]*" maxlength="6" placeholder="Código" onkeydown="return (
                            event.ctrlKey ||
                            event.altKey ||
                            (47 < event.keyCode && event.keyCode < 58 && event.shiftKey == false) ||
                            (95 < event.keyCode && event.keyCode < 106) ||
                            event.keyCode == 8 ||
                            event.keyCode == 9 ||
                            (event.keyCode > 34 && event.keyCode < 40) ||
                            event.keyCode == 46
                        )">
                </mat-form-field>
            </div>
            <!-- Confirmar -->
            <button class="code-submit" mat-raised-button type="submit" [disabled]="codeConfirmForm.invalid">
                CONFIRMAR
            </button>
            <!-- Reenviar código -->
            <button class="code-resend" mat-raised-button type="button" [disabled]="!minutePassed || codeAlreadyShown"
                (click)="resendCode()">
                {{
                codeAlreadyShown
                ? 'CÓDIGO CARGADO'
                : !minutePassed
                ? 'REENVIAR CÓDIGO (' + formatCountdown() + ')'
                : 'REENVIAR CÓDIGO'
                }}
            </button>
        </form>
    </div>
</mat-dialog-content>